import { adminFetch } from "./_client";
import type { Airport, AirportsSyncResult } from "./types";


export function fetchAirports(token: string, page = 1, search = "") {
  const params = new URLSearchParams({ page: String(page) });
  if (search) params.set("search", search);
  return adminFetch<{ airports: Airport[]; total: number; page: number; limit: number }>(`/admin/airports?${params}`, token);
}


export function createAirport(token: string, airport: { name: string; iata_code: string; city?: string | null; state?: string | null; country: string; latitude?: number | null; longitude?: number | null; is_active?: boolean }) {
  return adminFetch<Airport>("/admin/airports", token, {
    method: "POST",
    body: JSON.stringify(airport),
  });
}


export function updateAirport(token: string, id: number, airport: { name?: string; iata_code?: string; city?: string | null; state?: string | null; country?: string; latitude?: number | null; longitude?: number | null; is_active?: boolean }) {
  return adminFetch<Airport>(`/admin/airports/${id}`, token, {
    method: "PUT",
    body: JSON.stringify(airport),
  });
}


export function toggleAirport(token: string, id: number) {
  return adminFetch<{ id: number; is_active: boolean }>(`/admin/airports/${id}/toggle`, token, { method: "PUT" });
}


export function fetchAirportsSyncStatus(token: string) {
  return adminFetch<{ lastSync: AirportsSyncResult | null }>("/admin/airports/sync-status", token);
}


export function resyncAirports(token: string) {
  return adminFetch<{ success: boolean; result?: AirportsSyncResult; error?: string }>(
    "/admin/airports/resync",
    token,
    { method: "POST" },
  );
}


export function deleteAirport(token: string, id: number) {
  return adminFetch<{ success: boolean }>(`/admin/airports/${id}`, token, { method: "DELETE" });
}
